import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoSearchResults({
  className
}) {
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.2248 24.7393C21.471 24.8128 25.7835 20.6196 25.8571 15.3734C25.9306 10.1272 21.7374 5.81471 16.4912 5.74115C11.245 5.66759 6.93249 9.86084 6.85893 15.107C6.80562 18.9092 8.99355 22.221 12.1992 23.7841L9.9192 29.7552L8.99555 29.4025L6.1418 36.8762C5.74778 37.9081 6.26489 39.064 7.29679 39.4581C8.32869 39.8521 9.48463 39.335 9.87865 38.3031L12.7324 30.8294L11.7876 30.4686L14.08 24.4652C14.768 24.6345 15.486 24.7289 16.2248 24.7393ZM16.2529 22.7395C20.3946 22.7976 23.7992 19.4871 23.8573 15.3454C23.9153 11.2036 20.6049 7.79903 16.4631 7.74095C12.3214 7.68288 8.91681 10.9933 8.85874 15.1351C8.80067 19.2768 12.1111 22.6814 16.2529 22.7395Z",
      fill: "#333"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.2969 13.6572C46.3917 11.1109 50.3403 10.4716 51.2328 12.8591C52.1253 15.2466 48.8299 16.7931 48.8299 16.7931L49.0693 18.2739M54.2116 19.8991C54.2793 18.0789 57.1018 17.622 57.7398 19.3286C58.3778 21.0352 56.0222 22.1407 56.0222 22.1407L56.1933 23.1992",
      stroke: "#333",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "49.4124",
      cy: "20.3725",
      r: "1",
      transform: "rotate(-9.18449 49.4124 20.3725)",
      fill: "#333"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "56.4369",
      cy: "24.699",
      r: "0.714816",
      transform: "rotate(-9.18449 56.4369 24.699)",
      fill: "#333"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 38V59.5H54.5V34.5H44L41.5 38H21Z",
      stroke: "#333",
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("rect", {
      x: "24",
      y: "42.5",
      width: "13",
      height: "2",
      rx: "1",
      fill: "#333"
    }), /*#__PURE__*/_jsx("rect", {
      x: "24",
      y: "46.5",
      width: "17",
      height: "2",
      rx: "1",
      fill: "#333"
    }), /*#__PURE__*/_jsx("rect", {
      x: "24",
      y: "50.5",
      width: "17",
      height: "2",
      rx: "1",
      fill: "#333"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.5 37.5L33 23L51 26L49.5 34.5M25 38L27.3276 24.5L32.3276 25.5",
      stroke: "#333",
      strokeWidth: "2",
      strokeLinejoin: "round"
    })]
  });
}